import React, { useEffect, useRef } from "react";
import gsap from "gsap";

import Target from "./Cursor/target";
import PageTransition from "./page-transition";
import ConnectWithMe from "../svgs/connect-nav.svg";

import "../styles/navigation.scss";

const NavigationMenu: React.FC<any> = ({ state, closeMenu }) => {
  const menuRef = useRef(null);
  const revealMenu = useRef(null);
  const revealMenuBackground = useRef(null);
  const nav1Rev = useRef(null);
  const nav2Rev = useRef(null);
  const nav3Rev = useRef(null);

  useEffect(() => {
    if (state.clicked === false) {
      gsap
        .timeline()
        .to([revealMenu.current, revealMenuBackground.current], {
          duration: .8,
          height: 0,
          ease: "power3.inOut",
          stagger: {
            amount: 0.07
          }
        })
        .to(menuRef.current, {
          duration: 1,
          css: { display: "none" }
        })
    } else if (state.clicked === true || state.clicked === true && state.initial === null) {
      gsap.to(menuRef.current, {
        duration: 0,
        css: { display: "block" }
      })
      gsap.to([revealMenuBackground.current, revealMenu.current], {
        duration: 0,
        height: '100%'
      });
      staggerReveal(revealMenuBackground.current, revealMenu.current);
      staggerText(nav1Rev.current, nav2Rev.current, nav3Rev.current);
    }
  }, [state]);

  const staggerReveal = (node1, node2) => {
    gsap.from([node1, node2], {
      duration: .8,
      height: 0,
      transformOrigin: 'right top',
      skewY: 2,
      ease: "power3.inOut",
      stagger: {
        amount: 0.1
      }
    });
  }

  const staggerText = (...nodes) => {
    gsap.from([...nodes], {
      duration: 0.8,
      y: 110,
      delay: 0.2,
      ease: "power3.inOut",
      stagger: {
        amount: 0.3
      }
    })
  }

  const openMailTo = () => {
    window.location.href = "mailto:tkhariprasath@gmail.com"
  }

  return (
    <div className="navigationMenu" ref={menuRef}>
      <div className="navigationMenu-background" ref={revealMenuBackground} />
      <div className="navigationMenu-layer" ref={revealMenu}>
        <div className="container">
          <div className="wrapper">
            <div className="menu-links">
              <nav>
                <ul>
                  <Target>
                    <li onClick={closeMenu}>
                      <PageTransition innerRef={i => nav1Rev.current = i} to="/works">My Works</PageTransition>
                    </li>
                  </Target>
                  <Target>
                    <li onClick={closeMenu}>
                      <PageTransition innerRef={i => nav2Rev.current = i} to="/about">About Me</PageTransition>
                    </li>
                  </Target>
                  <Target>
                    <li onClick={closeMenu}>
                      <PageTransition innerRef={i => nav3Rev.current = i} to="/resume">Resume</PageTransition>
                    </li>
                  </Target>
                </ul>
              </nav>
            </div>
            <div className="social-links">
              <nav>
                <ul>
                  <Target>
                    <li onClick={closeMenu}>
                      <PageTransition to="/works">Behance.</PageTransition>
                    </li>
                  </Target>
                  <Target><li>
                    <PageTransition to="/about">Dribble.</PageTransition>
                  </li></Target>
                  <Target><li>
                    <PageTransition to="/resume">Instagram.</PageTransition>
                  </li></Target>
                  <Target><li>
                    <PageTransition to="/resume">Linkedin.</PageTransition>
                  </li></Target>
                  <Target><li>
                    <PageTransition to="/resume">Facebook.</PageTransition>
                  </li></Target>
                  <Target><li>
                    <PageTransition to="/resume">Twitter.</PageTransition>
                  </li></Target>
                </ul>
              </nav>
            </div>
          </div>
          <div className="footer">
          <Target>
            <div className="connectwithme">
              <ConnectWithMe />
            </div>
          </Target>
            <Target className="emailme" onClick={openMailTo}>Or email me at<br />thhariprasath@gmail.com</Target>
          </div>
        </div>
      </div>
    </div>
  )
}

export default NavigationMenu;
